import { useState, useEffect } from 'react';
import Checkbox from 'components/checkbox';

function MultiSelectField(props: {
    id: string;
    label: string;
    extra?: string;
    variant?: string;
    state?: string;
    disabled?: boolean;
    onChange?: (selectedOptions: string[]) => void;
    defaultValue?: string[];
    value?: string[];
    options: string[];
    required?: boolean;
}) {
    const {
        label,
        id,
        extra,
        variant,
        state,
        disabled,
        onChange,
        defaultValue,
        value,
        options,
        required,
    } = props;

    const [selectedOptions, setSelectedOptions] = useState<string[]>(
        value || defaultValue || []
    );

    useEffect(() => {
        if (value !== undefined) {
            setSelectedOptions(value);
        }
    }, [value]);

    const handleCheckboxChange = (option: string, checked: boolean) => {
        let newSelection: string[];
        if (checked) {
            newSelection = [...selectedOptions, option];
        } else {
            newSelection = selectedOptions.filter((item) => item !== option);
        }
        setSelectedOptions(newSelection);
        if (onChange) {
            onChange(newSelection);
        }
    };

    return (
        <div className={`${extra}`}>
            <label
                htmlFor={id}
                className={`text-sm font-semibold text-gray-700 dark:text-white ${
                    variant === 'auth' ? 'ml-1' : 'ml-1'
                }`}
            >
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div
                className={`mt-2.5 flex w-full flex-col gap-3 rounded-xl border-2 bg-white p-4 text-base outline-none transition-all duration-200 ${
                    disabled === true
                        ? '!border-gray-200 !bg-gray-50 cursor-not-allowed'
                        : state === 'error'
                        ? 'border-red-400 bg-red-50/50'
                        : state === 'success'
                        ? 'border-green-400 bg-green-50/50'
                        : 'border-gray-200 hover:border-gray-300'
                }`}
            >
                {options.map((option, index) => (
                    <div key={index} className="flex items-center gap-3 group">
                        <Checkbox
                            id={`${id}-${index}`}
                            disabled={disabled}
                            defaultChecked={selectedOptions.includes(option)}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                handleCheckboxChange(option, e.target.checked)
                            }
                        />
                        <label
                            htmlFor={`${id}-${index}`}
                            className="text-sm font-medium text-gray-700 dark:text-white cursor-pointer select-none transition-colors group-hover:text-brand-600"
                        >
                            {option}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MultiSelectField;
